import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-exc-gay-number',
  templateUrl: './app-exc-gay-number.component.html',
  styles: []
})
export class AppExcGayNumberComponent implements OnInit {

  colors = {Default: 'rgba(32, 83, 148, 0.6)',
      Yellow: 'rgba(250, 169, 51, 0.6)',
      Green: 'rgba(3, 181, 56, 0.6)',
      Lightblue: 'rgba(88, 200, 224, 0.6)',
      Pink: 'rgba(181, 3, 154, 0.6)',
      Red: 'rgba(201, 48, 44, 0.6)'};
  @Input() Value: any;
  @Input() Label: string;
  @Input() Color: string;
  @Input() AlignRight = false;
  constructor() {
  }
  getStyle() {
      let color = this.colors.Default;
      if (this.Color && this.colors[this.Color] !== undefined) {
        color = this.colors[this.Color];
      }
      return {width:  'calc(100% - 0.5rem)'
        , padding: (this.Value === 0 ? '0' : '0 0.25rem 0 0.25rem')
        , lineHeight: '1.5rem'
        , minHeight: '1.5rem'
        , borderRadius: '4px' // 0 0 4px'
        , float: 'left'
        , backgroundColor: color
        // , visibility: this.Value === 0 ? 'hidden' : 'visible'
        , cursor: 'default'};
  }
  ngOnInit() {
  }

}
